// The app serves every route with a trailing slash (`trailingSlash: true` in next.config), so a
// shop link without one costs a 308 on every click. Relative shop paths get their slash before any
// query string or hash; external URLs, hashes and already-slashed paths pass through untouched.
export const withTrailingSlash = (href: string): string => {
  if (!href.startsWith('/') || href.endsWith('/')) return href;
  const end = href.search(/[?#]/);
  if (end === -1) return `${href}/`;
  return `${href.slice(0, end)}/${href.slice(end)}`;
};
